/** Parses the Light2D surface PointLight2D and DirectionalLight2D share, over the Node2D transform. */
import { parseNode2D } from '../../../base/node2d/parser';
import { floatOr, boolOr, enumOr, intOr } from '../../../../parser/valueParsers';
import { colorOr } from '../../../../utils/colorParser';
import { LIGHT_2D_RANGE_DEFAULTS } from './types';
import { Light2DBlendMode, Light2DShadowFilter } from '../../../../godot/scene/light2d';
const BLEND_MODES = Object.values(Light2DBlendMode);
const SHADOW_FILTERS = Object.values(Light2DShadowFilter);
export function parseLight2D(heading, properties) {
    const context = heading.attributes.type ?? 'Light2D';
    return {
        ...parseNode2D(heading, properties),
        enabled: boolOr(properties.enabled, true, context),
        color: colorOr(properties.color, { r: 1, g: 1, b: 1, a: 1 }),
        energy: floatOr(properties.energy, 1.0, context),
        blend_mode: enumOr(properties.blend_mode, Light2DBlendMode.ADD, BLEND_MODES, context),
        // Both default to 1, so a light with nothing authored reaches exactly the
        // items that also left `light_mask` alone.
        range_item_cull_mask: intOr(properties.range_item_cull_mask, LIGHT_2D_RANGE_DEFAULTS.itemCullMask, context),
        shadow_item_cull_mask: intOr(properties.shadow_item_cull_mask, 1, context),
        // `Light2D::set_z_range_min` and its three siblings assign with no CLAMP and
        // no reordering of the pair, so neither happens here.
        range_z_min: intOr(properties.range_z_min, LIGHT_2D_RANGE_DEFAULTS.zMin, context),
        range_z_max: intOr(properties.range_z_max, LIGHT_2D_RANGE_DEFAULTS.zMax, context),
        range_layer_min: intOr(properties.range_layer_min, LIGHT_2D_RANGE_DEFAULTS.layerMin, context),
        range_layer_max: intOr(properties.range_layer_max, LIGHT_2D_RANGE_DEFAULTS.layerMax, context),
        shadow_enabled: boolOr(properties.shadow_enabled, false, context),
        // Transparent black (`light_2d.h:58`): where a shadow falls, Godot mixes the light toward
        // nothing (`canvas.glsl:544-546`), so the surface keeps its unlit colour.
        shadow_color: colorOr(properties.shadow_color, { r: 0, g: 0, b: 0, a: 0 }),
        shadow_filter: enumOr(properties.shadow_filter, Light2DShadowFilter.NONE, SHADOW_FILTERS, context),
        shadow_filter_smooth: floatOr(properties.shadow_filter_smooth, 0.0, context),
    };
}
//# sourceMappingURL=parser.js.map